import React from 'react'
import MainLayout from '../../layout/MainLayout'
import Subscription from '../../components/Subscription/Subscription'

const SubscriptionPage = () => {
  return (
    <MainLayout>
        <Subscription />
    </MainLayout>
  )
}

export default SubscriptionPage